
import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import * as XLSX from 'xlsx';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';

const Rpt_WashReport = () => {

    const usershopid = localStorage.getItem('MYPCKARTUSER')
        ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id
        : '0';

    const today = new Date();

    const [FebData, setFebData] = useState([]);
    const [WData, setWData] = useState([]);
    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);
    const [lotSearch, setLotSearch] = useState('');

    const [frmdata, setfrmdata] = useState({
        fromdate: "2024-01-01",
        todate: today.toISOString().split('T')[0],
        deptcode: 0,
        status: 1
    });

    const [itemdetail, setitemdetail] = useState({
        Washername: "",
        Washercode: 0,
        fabname: "",
        fabcode: 0
    });

    const {
        fromdate,
        todate,
        status
    } = frmdata;

    const {
        fabcode,
        Washercode
    } = itemdetail;

    const tableRef = useRef(null);

    // ---------------------------------------------------------
    // Number formatter
    // ---------------------------------------------------------
    const formatNumber = (value) => {
        const num = Number(value || 0);

        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    // ---------------------------------------------------------
    // Change filter value
    // ---------------------------------------------------------
    const onChangevalue = (e) => {
        const { name, value } = e.target;

        const sanitizedValue = value.replace(
            /['"!`@#$%^&*+{}|;:,.<>?=]/g,
            ''
        );

        setfrmdata({
            ...frmdata,
            [name]: sanitizedValue
        });
    };

    // ---------------------------------------------------------
    // Washer change
    // ---------------------------------------------------------
    const onChangevalueFab = (fabcode, fabname) => {
        setitemdetail({
            ...itemdetail,
            fabcode: fabcode,
            fabname: fabname
        });
    };

    // ---------------------------------------------------------
    // Load report
    // ---------------------------------------------------------
    // const loaddata = async () => {
    //     try {
    //         setLoading(true);

    //         const billResponse = await axios.get(
    //             `${hostlink}/fatchWashReport/${usershopid}/${fromdate}/${todate}/${Washercode}/${fabcode}`
    //         );

    //         const billData = billResponse.data;

    //         const filteredData = billData.filter((res) => {

    //             const totalQuantity =
    //                 Number(res.stkInfab) +
    //                 Number(res.inQty);

    //             if (status == 0) {
    //                 return true;
    //             }

    //             if (status == 1) {
    //                 return totalQuantity !== 0;
    //             }

    //             if (status == 2) {
    //                 return res.inQty < 0;
    //             }

    //             return false;
    //         });

    //         setData(filteredData);

    //     } catch (error) {
    //         console.log("Data Not Found...", error);
    //         setData([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // };


const loaddata = async () => {
    try {
        setLoading(true);

        let billData = [];

        if (Number(status) === 2) {
            // Received entries directly from PurchaseMas
            const response = await axios.get(
                `${hostlink}/PurchaseMaskotviewreport/3/${usershopid}/${fromdate}/${todate}`
            );

            billData = response.data.map((item) => {
                const washer = WData.find(
                    (w) => Number(w.id) === Number(item.wcode)
                );

                return {
                    purchaseMas: item,
                    wasName: washer?.wname || "",
                    stkInfab: 0,
                    inQty: -Math.abs(Number(item.washqty || 0)),
                    inQty2: Number(item.alterwash || 0),
                    stkOutfab: item.wcode
                };
            });
        } else {
            // Existing sent/pending report
            const response = await axios.get(
                `${hostlink}/fatchWashReport/${usershopid}/${fromdate}/${todate}/${fabcode}/${Washercode}`
            );

            billData = response.data;
        }

        const result = billData.filter((res) => {
            if (Number(status) === 0) return true;

            if (Number(status) === 1) {
                const totalQuantity =
                    Number(res.stkInfab || 0) +
                    Number(res.inQty || 0);

                return totalQuantity !== 0;
            }

            if (Number(status) === 2) {
                return true;
            }

            return false;
        });

        setData(result);
    } catch (error) {
        console.error("Failed to load washing report:", error);
        setData([]);
    } finally {
        setLoading(false);
    }
};

    // ---------------------------------------------------------
    // Load masters
    // ---------------------------------------------------------
    useEffect(() => {

        axios.get(`${hostlink}/${usershopid}/WasherMas`)
            .then((response) => {
                setFebData(response.data);
            })
            .catch(() => {
                setFebData([]);
            });

        axios.get(`${hostlink}/${usershopid}/WasherMas`)
            .then((response) => {
                setWData(response.data);
            })
            .catch(() => {
                setWData([]);
            });

    }, [usershopid]);

    // ---------------------------------------------------------
    // Lot search
    // ---------------------------------------------------------
    const filteredData = useMemo(() => {

        const search = lotSearch.trim().toLowerCase();

        if (!search) {
            return data;
        }

        return data.filter((res) => {

            const lotNo =
                res?.purchaseMas?.billno ??
                res?.billno ??
                '';

            return String(lotNo)
                .toLowerCase()
                .includes(search);
        });

    }, [data, lotSearch]);

    // ---------------------------------------------------------
    // Summary
    // ---------------------------------------------------------
    const summary = useMemo(() => {

        let inQty = 0;
        let outQty = 0;
        let alter = 0;
        let pending = 0;

        filteredData.forEach((res) => {

            const inValue = Number(res.stkInfab || 0);
            const outValue = Number(res.inQty || 0) * -1;
            const alterValue = Number(res.inQty2 || 0);

            inQty += inValue;
            outQty += outValue;
            alter += alterValue;

            pending +=
                Number(res.stkInfab || 0) +
                Number(res.inQty || 0) -
                Number(res.inQty2 || 0);
        });

        return {
            lots: new Set(
                filteredData.map(
                    res => res?.purchaseMas?.billno
                )
            ).size,
            records: filteredData.length,
            inQty,
            outQty,
            alter,
            pending
        };

    }, [filteredData]);

    // ---------------------------------------------------------
    // Excel export
    // ---------------------------------------------------------
    const exportToExcel = () => {

        if (!tableRef.current) {
            return;
        }

        const ws = XLSX.utils.table_to_sheet(tableRef.current);

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            'Washing Report'
        );

        XLSX.writeFile(
            wb,
            'Washing Report.xlsx'
        );
    };

    // ---------------------------------------------------------
    // PDF filename
    // ---------------------------------------------------------
    const pdfFileName =
        lotSearch.trim()
            ? `Washing Report - Lot ${lotSearch}.pdf`
            : 'Washing Report.pdf';

    // ---------------------------------------------------------
    // Summary Card
    // ---------------------------------------------------------
    const SummaryCard = ({
        title,
        value,
        icon,
        subtitle
    }) => {

        return (
            <div className="col-6 col-md-4 col-xl-2">
                <div
                    className="bg-white h-100"
                    style={{
                        borderRadius: '16px',
                        padding: '16px',
                        boxShadow: '0 4px 18px rgba(0,0,0,0.06)',
                        border: '1px solid #edf0f5',
                        transition: 'all 0.2s ease'
                    }}
                >

                    <div
                        className="d-flex justify-content-between align-items-center"
                    >

                        <div>
                            <div
                                className="text-muted"
                                style={{
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}
                            >
                                {title}
                            </div>

                            <div
                                className="fw-bold mt-1"
                                style={{
                                    fontSize: '20px',
                                    color: '#1f2937'
                                }}
                            >
                                {value}
                            </div>

                            {subtitle && (
                                <div
                                    className="text-muted mt-1"
                                    style={{
                                        fontSize: '10px'
                                    }}
                                >
                                    {subtitle}
                                </div>
                            )}
                        </div>

                        <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '12px',
                                background:
                                    'linear-gradient(135deg,#eef4ff,#dfeaff)',
                                color: '#2563eb'
                            }}
                        >
                            <i className={`fa-solid ${icon}`}></i>
                        </div>

                    </div>
                </div>
            </div>
        );
    };

    return (

        <div
            className="container-fluid py-3"
            style={{
                background: '#f6f8fb',
                minHeight: '100vh'
            }}
        >

            {/* =====================================================
                HEADER + FILTER
            ====================================================== */}
            <div
                className="card border-0 mb-3"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow: '0 6px 24px rgba(15,23,42,0.07)'
                }}
            >

                {/* Header */}
                <div
                    style={{
                        background:
                            'linear-gradient(135deg,#0d6efd,#315efb)',
                        padding: '18px 20px',
                        color: '#fff'
                    }}
                >

                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

                        <div className="d-flex align-items-center">

                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '14px',
                                    background: 'rgba(255,255,255,0.18)',
                                    backdropFilter: 'blur(8px)'
                                }}
                            >
                                <i
                                    className="fa-solid fa-recycle"
                                    style={{ fontSize: '21px' }}
                                ></i>
                            </div>

                            <div>

                                <div
                                    style={{
                                        fontSize: '20px',
                                        fontWeight: '700'
                                    }}
                                >
                                    Washing Report
                                </div>

                                <div
                                    style={{
                                        fontSize: '12px',
                                        opacity: 0.85
                                    }}
                                >
                                    Washing / Washer pending movement
                                </div>

                            </div>

                        </div>

                        <div
                            className="badge rounded-pill"
                            style={{
                                background: 'rgba(255,255,255,0.16)',
                                padding: '9px 13px',
                                fontSize: '11px'
                            }}
                        >
                            {filteredData.length} Records
                        </div>

                    </div>
                </div>

                {/* Filters */}
                <div className="card-body p-3">

                    <div className="row g-2 align-items-end">

                        {/* WASHER */}
                        <div className="col-12 col-md-3 col-lg-2">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Washer
                            </label>

                            <select
                                id="fabname"
                                value={itemdetail.fabcode || 0}
                                onChange={(e) => {

                                    const selectedIndex =
                                        e.target.selectedIndex;

                                    const selectedCode =
                                        e.target.value;

                                    const selectedName =
                                        e.target.options[selectedIndex].text;

                                    onChangevalueFab(
                                        selectedCode,
                                        selectedName
                                    );
                                }}
                                name="fabname"
                                className="form-select form-select-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                            >

                                <option value={0}>
                                    All Washers
                                </option>

                                {FebData.map((x) => (
                                    <option
                                        key={x.id}
                                        value={x.id}
                                    >
                                        {x.wname}
                                    </option>
                                ))}

                            </select>

                        </div>

                        {/* LOT SEARCH */}
                        <div className="col-12 col-md-4 col-lg-3">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Lot No
                            </label>

                            <div className="input-group input-group-sm">

                                <span
                                    className="input-group-text"
                                    style={{
                                        background: '#fff',
                                        borderRadius: '10px 0 0 10px'
                                    }}
                                >
                                    <i className="fa-solid fa-magnifying-glass text-primary"></i>
                                </span>

                                <input
                                    type="text"
                                    value={lotSearch}
                                    onChange={(e) =>
                                        setLotSearch(e.target.value)
                                    }
                                    placeholder="Search Lot No..."
                                    className="form-control"
                                    style={{
                                        borderRadius: '0 10px 10px 0'
                                    }}
                                />

                            </div>

                        </div>

                        {/* FROM DATE */}
                        <div className="col-6 col-md-2 col-lg-2">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                From Date
                            </label>

                            <input
                                type="date"
                                id="fromdate"
                                name="fromdate"
                                value={fromdate}
                                max={todate}
                                onChange={onChangevalue}
                                className="form-control form-control-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                            />

                        </div>

                        {/* TO DATE */}
                        <div className="col-6 col-md-2 col-lg-2">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                To Date
                            </label>

                            <input
                                type="date"
                                id="todate"
                                name="todate"
                                value={todate}
                                min={fromdate}
                                onChange={onChangevalue}
                                className="form-control form-control-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                            />

                        </div>

                        {/* STATUS */}
                        <div className="col-12 col-md-2 col-lg-2">

                            <label
                                className="form-label mb-1"
                                style={{
                                    fontSize: '12px',
                                    fontWeight: '600'
                                }}
                            >
                                Status
                            </label>

                            <select
                                id="status"
                                name="status"
                                value={status}
                                onChange={onChangevalue}
                                className="form-select form-select-sm"
                                style={{
                                    borderRadius: '10px'
                                }}
                            >

                                <option value={0}>
                                    All
                                </option>

                                <option value={1}>
                                    Pending
                                </option>

                                <option value={2}>
                                    Received
                                </option>

                            </select>

                        </div>

                    </div>

                    {/* ACTIONS */}
                    <div className="d-flex justify-content-end flex-wrap gap-2 mt-3">

                        <button
                            onClick={loaddata}
                            className="btn btn-primary btn-sm px-3"
                            style={{
                                borderRadius: '10px',
                                fontWeight: '600'
                            }}
                        >
                            {loading ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                    ></span>
                                    Loading
                                </>
                            ) : (
                                <>
                                    <i className="fa-solid fa-magnifying-glass-chart me-1"></i>
                                    Show
                                </>
                            )}
                        </button>

                        <button
                            onClick={exportToExcel}
                            className="btn btn-outline-success btn-sm px-3"
                            style={{
                                borderRadius: '10px',
                                fontWeight: '600'
                            }}
                        >
                            <i className="fa-solid fa-file-excel me-1"></i>
                            Excel
                        </button>

                        <PDFDownloadLink
                            document={
                                <PDFDocument
                                    data={filteredData}
                                    fromdate={fromdate}
                                    todate={todate}
                                />
                            }
                            fileName={pdfFileName}
                            style={{
                                textDecoration: 'none'
                            }}
                        >
                            {({ loading: pdfLoading }) => (

                                <button
                                    className="btn btn-outline-danger btn-sm px-3"
                                    style={{
                                        borderRadius: '10px',
                                        fontWeight: '600'
                                    }}
                                >
                                    <i className="fa-solid fa-file-pdf me-1"></i>

                                    {pdfLoading
                                        ? 'Loading'
                                        : 'PDF'}
                                </button>

                            )}
                        </PDFDownloadLink>

                    </div>

                </div>
            </div>

            {/* =====================================================
                SUMMARY CARDS
            ====================================================== */}
            <div className="row g-2 mb-3">

                <SummaryCard
                    title="Lots"
                    value={summary.lots}
                    icon="fa-boxes-stacked"
                    subtitle="Unique lot numbers"
                />

                <SummaryCard
                    title="Records"
                    value={summary.records}
                    icon="fa-list"
                    subtitle="Report records"
                />

                <SummaryCard
                    title="In Qty"
                    value={formatNumber(summary.inQty)}
                    icon="fa-arrow-right-to-bracket"
                    subtitle="Received by washer"
                />

                <SummaryCard
                    title="Out Qty"
                    value={formatNumber(summary.outQty)}
                    icon="fa-arrow-right-from-bracket"
                    subtitle="Sent from washer"
                />

                <SummaryCard
                    title="Alter"
                    value={formatNumber(summary.alter)}
                    icon="fa-scissors"
                    subtitle="Alter quantity"
                />

                <SummaryCard
                    title="Pending"
                    value={formatNumber(summary.pending)}
                    icon="fa-hourglass-half"
                    subtitle="Current pending"
                />

            </div>

            {/* =====================================================
                ACTIVE SEARCH
            ====================================================== */}
            {(lotSearch || status != 1 || fabcode != 0) && (

                <div
                    className="bg-white mb-3 px-3 py-2"
                    style={{
                        borderRadius: '12px',
                        border: '1px solid #e9edf3',
                        boxShadow: '0 3px 12px rgba(0,0,0,0.04)'
                    }}
                >

                    <div className="d-flex align-items-center flex-wrap gap-2">

                        <span
                            className="text-muted"
                            style={{
                                fontSize: '11px',
                                fontWeight: '600'
                            }}
                        >
                            Active Filters:
                        </span>

                        {lotSearch && (
                            <span className="badge bg-primary rounded-pill">
                                Lot: {lotSearch}
                            </span>
                        )}

                        {fabcode != 0 && (
                            <span className="badge bg-info rounded-pill">
                                Washer: {itemdetail.fabname}
                            </span>
                        )}

                        {status == 0 && (
                            <span className="badge bg-secondary rounded-pill">
                                All
                            </span>
                        )}

                        {status == 2 && (
                            <span className="badge bg-success rounded-pill">
                                Received
                            </span>
                        )}

                    </div>

                </div>
            )}

            {/* =====================================================
                TABLE
            ====================================================== */}
            <div
                className="card border-0"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow: '0 6px 24px rgba(15,23,42,0.07)'
                }}
            >

                <div
                    className="card-header bg-white border-0 d-flex justify-content-between align-items-center flex-wrap gap-2"
                    style={{
                        padding: '15px 18px'
                    }}
                >

                    <div>

                        <div
                            className="fw-bold"
                            style={{
                                color: '#1f2937'
                            }}
                        >
                            Washing Details
                        </div>

                        <small className="text-muted">
                            Lot-wise washing movement
                        </small>

                    </div>

                    <div
                        className="badge rounded-pill"
                        style={{
                            background: '#eef4ff',
                            color: '#2563eb',
                            padding: '8px 12px'
                        }}
                    >
                        {filteredData.length} rows
                    </div>

                </div>

                <div
                    style={{
                        overflowX: 'auto',
                        maxHeight: '65vh'
                    }}
                >

                    <table
                        ref={tableRef}
                        className="table table-hover align-middle mb-0"
                        style={{
                            minWidth: '900px',
                            fontSize: '13px'
                        }}
                    >

                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 5,
                                background: '#f1f5f9'
                            }}
                        >

                            <tr>

                                <th
                                    className="text-start"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Lot No
                                </th>

                                <th
                                    className="text-start"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Washer
                                </th>

                                <th
                                    className="text-start"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Style
                                </th>

                                <th
                                    className="text-start"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Size
                                </th>

                                <th
                                    className="text-end"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    In Qty
                                </th>

                                <th
                                    className="text-end"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Out Qty
                                </th>

                                <th
                                    className="text-end"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Alter
                                </th>

                                <th
                                    className="text-end"
                                    style={{
                                        padding: '12px 14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Pending
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {loading ? (

                                <tr>
                                    <td
                                        colSpan="8"
                                        className="text-center"
                                        style={{
                                            padding: '50px'
                                        }}
                                    >
                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        ></div>

                                        <div
                                            className="text-muted mt-2"
                                            style={{
                                                fontSize: '12px'
                                            }}
                                        >
                                            Loading washing report...
                                        </div>
                                    </td>
                                </tr>

                            ) : filteredData.length === 0 ? (

                                <tr>
                                    <td
                                        colSpan="8"
                                        className="text-center"
                                        style={{
                                            padding: '60px 20px'
                                        }}
                                    >

                                        <div
                                            className="d-flex align-items-center justify-content-center mx-auto mb-3"
                                            style={{
                                                width: '58px',
                                                height: '58px',
                                                borderRadius: '18px',
                                                background: '#f1f5f9',
                                                color: '#94a3b8'
                                            }}
                                        >
                                            <i
                                                className="fa-solid fa-box-open"
                                                style={{
                                                    fontSize: '24px'
                                                }}
                                            ></i>
                                        </div>

                                        <div
                                            className="fw-bold text-dark"
                                        >
                                            No washing records found
                                        </div>

                                        <div
                                            className="text-muted mt-1"
                                            style={{
                                                fontSize: '12px'
                                            }}
                                        >
                                            Try changing the date, washer,
                                            status or Lot No search.
                                        </div>

                                    </td>
                                </tr>

                            ) : (

                                filteredData.map((res, index) => {

                                    const lotNo =
                                        res?.purchaseMas?.billno ??
                                        res?.billno ??
                                        '';

                                    const inQty =
                                        Number(res.stkInfab || 0);

                                    const outQty =
                                        Number(res.inQty || 0) * -1;

                                    const alter =
                                        Number(res.inQty2 || 0);

                                    const pending =
                                        Number(res.stkInfab || 0) +
                                        Number(res.inQty || 0) -
                                        Number(res.inQty2 || 0);

                                    return (

                                        <tr key={index}>

                                            <td
                                                className="text-start fw-semibold"
                                                style={{
                                                    padding: '11px 14px',
                                                    color: '#2563eb'
                                                }}
                                            >
                                                {lotNo}
                                            </td>

                                            <td
                                                className="text-start"
                                                style={{
                                                    padding: '11px 14px'
                                                }}
                                            >
                                                {res.wasName}
                                            </td>

                                            <td
                                                className="text-start"
                                                style={{
                                                    padding: '11px 14px'
                                                }}
                                            >
                                                {res?.purchaseMas?.style}
                                            </td>

                                            <td
                                                className="text-start"
                                                style={{
                                                    padding: '11px 14px'
                                                }}
                                            >
                                                {res?.purchaseMas?.size}
                                            </td>

                                            <td
                                                className="text-end"
                                                style={{
                                                    padding: '11px 14px'
                                                }}
                                            >
                                                {formatNumber(inQty)}
                                            </td>

                                            <td
                                                className="text-end"
                                                style={{
                                                    padding: '11px 14px'
                                                }}
                                            >
                                                {formatNumber(outQty)}
                                            </td>

                                            <td
                                                className="text-end"
                                                style={{
                                                    padding: '11px 14px'
                                                }}
                                            >
                                                {formatNumber(alter)}
                                            </td>

                                            <td
                                                className="text-end fw-bold"
                                                style={{
                                                    padding: '11px 14px',
                                                    color:
                                                        pending > 0
                                                            ? '#dc2626'
                                                            : '#16a34a'
                                                }}
                                            >
                                                {formatNumber(pending)}
                                            </td>

                                        </tr>
                                    );
                                })

                            )}

                        </tbody>

                        {!loading && filteredData.length > 0 && (

                            <tfoot>

                                <tr
                                    style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 4,
                                        background: '#eaf2ff',
                                        borderTop: '2px solid #cbd5e1'
                                    }}
                                >

                                    <td></td>
                                    <td></td>
                                    <td></td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px'
                                        }}
                                        data-exclude="false"
                                    >
                                        Total
                                    </td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px'
                                        }}
                                    >
                                        {formatNumber(summary.inQty)}
                                    </td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px'
                                        }}
                                    >
                                        {formatNumber(summary.outQty)}
                                    </td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px'
                                        }}
                                    >
                                        {formatNumber(summary.alter)}
                                    </td>

                                    <td
                                        className="text-end fw-bold"
                                        style={{
                                            padding: '13px 14px',
                                            color:
                                                summary.pending > 0
                                                    ? '#dc2626'
                                                    : '#16a34a'
                                        }}
                                    >
                                        {formatNumber(summary.pending)}
                                    </td>

                                </tr>

                            </tfoot>
                        )}

                    </table>

                </div>

            </div>

        </div>
    );
};


// =============================================================
// PDF DOCUMENT
// =============================================================
const PDFDocument = ({
    data,
    fromdate,
    todate
}) => {

    const totalIn = data.reduce(
        (total, res) =>
            total + Number(res.stkInfab || 0),
        0
    );

    const totalOut = data.reduce(
        (total, res) =>
            total + Number(res.inQty || 0) * -1,
        0
    );

    const totalAlter = data.reduce(
        (total, res) =>
            total + Number(res.inQty2 || 0),
        0
    );

    const totalPending = data.reduce(
        (total, res) =>
            total +
            Number(res.stkInfab || 0) +
            Number(res.inQty || 0) -
            Number(res.inQty2 || 0),
        0
    );

    const formatNumber = (value) => {
        return Number(value || 0).toFixed(2);
    };

    return (
        <Document>

            <Page
                orientation="landscape"
                size="A4"
                style={pdfStyles.page}
            >

                <Text style={pdfStyles.title}>
                    Washing Report
                </Text>

                <Text style={pdfStyles.subTitle}>
                    From : {fromdate}    To : {todate}
                </Text>

                <View style={pdfStyles.table}>

                    {/* HEADER */}
                    <View style={pdfStyles.tableRow}>

                        <Text style={pdfStyles.headerCell}>
                            Lot No
                        </Text>

                        <Text style={pdfStyles.headerCell}>
                            Washer
                        </Text>

                        <Text style={pdfStyles.headerCell}>
                            Style
                        </Text>

                        <Text style={pdfStyles.headerCell}>
                            Size
                        </Text>

                        <Text style={pdfStyles.headerCell}>
                            In Qty
                        </Text>

                        <Text style={pdfStyles.headerCell}>
                            Out Qty
                        </Text>

                        <Text style={pdfStyles.headerCell}>
                            Alter
                        </Text>

                        <Text style={pdfStyles.headerCell}>
                            Pending
                        </Text>

                    </View>

                    {/* DATA */}
                    {data.map((res, index) => {

                        const pending =
                            Number(res.stkInfab || 0) +
                            Number(res.inQty || 0) -
                            Number(res.inQty2 || 0);

                        return (

                            <View
                                key={index}
                                style={pdfStyles.tableRow}
                            >

                                <Text style={pdfStyles.cell}>
                                    {res?.purchaseMas?.billno}
                                </Text>

                                <Text style={pdfStyles.cell}>
                                    {res.wasName}
                                </Text>

                                <Text style={pdfStyles.cell}>
                                    {res?.purchaseMas?.style}
                                </Text>

                                <Text style={pdfStyles.cell}>
                                    {res?.purchaseMas?.size}
                                </Text>

                                <Text style={pdfStyles.cell}>
                                    {formatNumber(res.stkInfab)}
                                </Text>

                                <Text style={pdfStyles.cell}>
                                    {formatNumber(
                                        Number(res.inQty || 0) * -1
                                    )}
                                </Text>

                                <Text style={pdfStyles.cell}>
                                    {formatNumber(res.inQty2)}
                                </Text>

                                <Text style={pdfStyles.cell}>
                                    {formatNumber(pending)}
                                </Text>

                            </View>
                        );
                    })}

                    {/* TOTAL */}
                    <View style={pdfStyles.totalRow}>

                        <Text style={pdfStyles.cell}></Text>

                        <Text style={pdfStyles.cell}></Text>

                        <Text style={pdfStyles.cell}></Text>

                        <Text style={pdfStyles.totalCell}>
                            Total :
                        </Text>

                        <Text style={pdfStyles.totalCell}>
                            {formatNumber(totalIn)}
                        </Text>

                        <Text style={pdfStyles.totalCell}>
                            {formatNumber(totalOut)}
                        </Text>

                        <Text style={pdfStyles.totalCell}>
                            {formatNumber(totalAlter)}
                        </Text>

                        <Text style={pdfStyles.totalCell}>
                            {formatNumber(totalPending)}
                        </Text>

                    </View>

                </View>

            </Page>

        </Document>
    );
};


// =============================================================
// PDF STYLES
// =============================================================
const pdfStyles = StyleSheet.create({

    page: {
        padding: 20,
        fontSize: 8
    },

    title: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 6,
        textAlign: 'center'
    },

    subTitle: {
        fontSize: 9,
        marginBottom: 15,
        textAlign: 'center'
    },

    table: {
        display: 'table',
        width: '100%',
        borderWidth: 1,
        borderColor: '#444'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#999'
    },

    headerCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#999'
    },

    cell: {
        fontSize: 8,
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#ddd'
    },

    totalRow: {
        flexDirection: 'row',
        backgroundColor: '#eaf2ff',
        borderTopWidth: 1,
        borderColor: '#555'
    },

    totalCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 5,
        flex: 1,
        textAlign: 'center',
        borderRightWidth: 1,
        borderColor: '#999'
    }

});

export default Rpt_WashReport;

